<template>
  <div :class="{ 'no-scroll': appStore.noScroll }">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <component
      :is="'noscript'"
      data-cookieconsent="ignore"
    >
      <iframe
        :src="`https://www.googletagmanager.com/ns.html?id=${gtmId}`"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      />
    </component>
  </div>
</template>

<script lang="ts" setup>
  import { useAppStore } from './stores'

  const appStore = useAppStore()
  const { locale } = useI18n()

  const config = useRuntimeConfig()

  const gtmId = computed(() => config.public.gtm)

  useHead(() => {
    return {
      htmlAttrs: {
        lang: locale.value,
        class: appStore.noScroll ? 'no-scroll' : ''
      },
      script: [
        {
          key: 'cookiebot',
          src: 'https://consent.cookiebot.com/uc.js',
          'data-cbid': '01329a2d-0b46-4689-bf00-62310677e33c',
          'data-blockingmode': 'auto',
          'data-culture': locale.value,
          type: 'text/javascript',
          async: true,
          tagPriority: 'after:script:gtagHead'
        }
      ]
    }
  })
</script>

<style lang="scss">
  @import '~/assets/styles/common.scss';

  .no-scroll {
    overflow: hidden;
  }
</style>
